export default __webpack_public_path__ + "media/images/loader/atlanticstudios.svg";